import { create } from "zustand";
import type { ClientsOverviewState } from "./types";

const useClientsOverviewStore = create<ClientsOverviewState>((set, get) => ({
    clientsOverviewData: undefined,
    setClientsOverviewData: (data) => set({ clientsOverviewData: data }),
    findClientByName: (name) => {
        const data = get().clientsOverviewData;
        if (!data) return undefined;
        return data.top_clients.find((client) => client.cliente.name === name);
    },
}));

export { useClientsOverviewStore };
